/* eslint-disable no-extra-boolean-cast */
/* eslint-disable no-unused-vars */
/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { useFormik } from 'formik';
import * as yup from 'yup';
import * as validation from '@constants/validation/validation';

import { showSuccessNotification } from '@components/common/Notifications';
import { CustomHelperText } from '@components/common/CustomHelperText';
import { handleInvalidError } from '@utils/handleInvalidError';
import { isMobile } from '@utils/mobileDetect';

import { Box, Grid, Button, Typography } from '@material-ui/core';
import { CustomTextField } from '@components/common/CustomTextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import SearchIcon from '@material-ui/icons/Search';
import { styled } from '@material-ui/styles';

import { Wrapper } from '@shared/Wrapper';
import { Auth } from '@api/requests';
import { useCompanyAutocomplete } from 'src/hooks/useCompanyAutocomplete';

import { ReactComponent as GoogleIcon } from '@assets/svg/icons/google-logo.svg';
import jwtDecode from 'jwt-decode';
import { successLogin } from 'src/store/thunks/auth';
import { showErrorNotification } from 'src/components/common/Notifications';
import { useDispatch } from 'react-redux';
import { GoogleLogin } from '@react-oauth/google';
import { useStyles } from './styles';

export const StepTwo = ({ onGoogleSuccess }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const history = useHistory();
  const { setCompanyQuery, companyQuery, companyOptions, companyIsLoading } = useCompanyAutocomplete();

  const formik = useFormik({
    initialValues: {
      tile: '',
      email: '',
      password: '',
      linkedin: '',
      last_name: '',
      c_password: '',
      first_name: '',
      company: undefined,
      company_name: undefined,
      company_uen: undefined,
    },
    validationSchema: yup.object().shape({
      tile: validation.TILE,
      email: validation.EMAIL,
      company: yup.mixed().test('company-required', 'Please choose your company or add new', val => val !== undefined),
      company_name: yup.string().when('company', {
        is: company => company === null,
        then: validation.COMPANY,
        otherwise: yup.string(),
      }),
      company_uen: yup.string().when('company', {
        is: company => company === null,
        then: validation.COMPANY,
        otherwise: yup.string(),
      }),
      password: validation.PASSWORD,
      last_name: validation.LAST_NAME,
      first_name: validation.FIRST_NAME,
      c_password: validation.PASSWORD_CONFIRMATION,
    }),
    onSubmit: ({ company, ...values }) => {
      Auth.register({
        ...values,
        company: company ?? undefined,
      })
        .then(res => {
          if (res.success) {
            formik.setSubmitting(false);
            showSuccessNotification(
              "We've sent you an email. Click the link in the email to confirm your address and activate your account.",
              5000
            );
            if (process.env.NODE_ENV === 'production') {
              window.gtag('event', 'submit', {
                event_category: 'form',
                event_label: 'Create Account',
              });
            }
            history.push('/');
          }
        })
        .catch(e => {
          formik.setSubmitting(false);
          handleInvalidError(formik.setErrors)(e);
        });
    },
  });

  const selectedCompanyOption = useMemo(() => {
    if (formik.values.company == null) return null;
    return companyOptions.find(option => option.id.toString() === formik.values.company.toString()) ?? null;
  }, [companyOptions, formik.values.company]);

  const handleSearchCompany = (e, value) => {
    const query = value ?? e?.currentTarget?.value ?? '';
    setCompanyQuery(query);
    if ((query === '' || query == null) && formik.values.company !== null) {
      formik.setFieldValue('company', undefined, false);
    }
  };

  return (
    <form onSubmit={formik.handleSubmit}>
      <Box className={classes.stepTwo}>
        <Grid container spacing={isMobile ? 3 : 5}>
          <Grid item xs={12}>
            <Wrapper
              padding={isMobile ? '24px 0px 0px' : '40px'}
              shadow={isMobile ? 'false' : '4px 8px 24px rgba(0, 0, 0, 0.04)'}
              borderRadius="8px"
            >
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <GoogleButtonWrapper>
                    <GoogleLogin
                      onSuccess={async response => {
                        const { credential } = response;

                        if (!credential || typeof onGoogleSuccess !== 'function') return;

                        try {
                          const { email } = jwtDecode(credential);
                          const checkRes = await Auth.googleAuthCheck({ email });

                          if (checkRes?.data?.exists) {
                            const payload = await Auth.googleAuth({ token: credential });
                            history.push('/account/dashboard');
                            dispatch(successLogin(payload.data));
                            return;
                          }

                          onGoogleSuccess(credential);
                        } catch (e) {
                          if (typeof e?.response?.data?.message === 'string') {
                            showErrorNotification(e.response.data.message, 5000);
                          }
                        }
                      }}
                    />
                  </GoogleButtonWrapper>
                </Grid>
                <Grid item xs={12}>
                  <Box className={classes.orDivider}>
                    <Box className={classes.orLine} />
                    <Typography className={classes.orText}>or</Typography>
                    <Box className={classes.orLine} />
                  </Box>
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <CustomTextField
                    type="text"
                    name="first_name"
                    placeholder="First Name *"
                    onBlur={formik.handleBlur}
                    helpertextposabsl="true"
                    onChange={formik.handleChange}
                    value={formik.values.first_name}
                    helperText={formik.touched.first_name && formik.errors.first_name}
                    error={Boolean(formik.touched.first_name && formik.errors.first_name)}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <CustomTextField
                    type="text"
                    name="last_name"
                    placeholder="Last Name *"
                    onBlur={formik.handleBlur}
                    helpertextposabsl="true"
                    onChange={formik.handleChange}
                    value={formik.values.last_name}
                    helperText={formik.touched.last_name && formik.errors.last_name}
                    error={Boolean(formik.touched.last_name && formik.errors.last_name)}
                  />
                </Grid>
                <Grid item xs={12}>
                  <CustomTextField
                    type="text"
                    name="tile"
                    placeholder="Position *"
                    onBlur={formik.handleBlur}
                    value={formik.values.tile}
                    helpertextposabsl="true"
                    onChange={formik.handleChange}
                    helperText={formik.touched.tile && formik.errors.tile}
                    error={Boolean(formik.touched.tile && formik.errors.tile)}
                  />
                </Grid>
                {formik.values.company !== null && (
                  <Grid item xs={12}>
                    <AutoCompleteWrapper error={Boolean(formik.touched.company && formik.errors.company).toString()}>
                      <Autocomplete
                        value={selectedCompanyOption}
                        inputValue={companyQuery}
                        options={companyOptions}
                        loading={companyIsLoading}
                        getOptionLabel={option => (option ? option.name : '')}
                        noOptionsText={
                          formik.values.company === null ? undefined : (
                            <Button
                              onMouseDown={e => e.preventDefault()}
                              onClick={() => {
                                setCompanyQuery('');
                                formik.setFieldValue('company', null);
                              }}
                            >
                              <span role="img" aria-label="add">
                                ➕
                              </span>
                              <span> Add new company</span>
                            </Button>
                          )
                        }
                        renderInput={params => (
                          <div ref={params.InputProps.ref} className={classes.inputContainer}>
                            <SearchIcon className={classes.icon} />
                            <input
                              type="text"
                              {...params.inputProps}
                              name="company"
                              placeholder="Select company"
                              className={classes.searchAutocompleteInput}
                            />
                          </div>
                        )}
                        onBlur={() => formik.setTouched({ ...formik.touched, company: true })}
                        onChange={(e, value) => {
                          if (value) {
                            setCompanyQuery(value.name);
                            formik.setFieldValue('company', value.id, true);
                            formik.setFieldValue('company_name', undefined, false);
                            if (value.uen != null) {
                              formik.setFieldValue('company_uen', undefined, false);
                            }
                          }
                        }}
                        onInputChange={handleSearchCompany}
                      />
                    </AutoCompleteWrapper>
                    {formik.touched.company && formik.errors.company && (
                      <CustomHelperText>{formik.errors.company}</CustomHelperText>
                    )}
                  </Grid>
                )}

                {formik.values.company === null && (
                  <>
                    <Grid item xs={12} sm={6}>
                      <CustomTextField
                        type="text"
                        name="company_name"
                        placeholder="Your company name"
                        value={formik.values.company_name}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        className={classes.input}
                        helperText={formik.touched.company_name && formik.errors.company_name}
                        error={Boolean(formik.touched.company_name && formik.errors.company_name)}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <CustomTextField
                        type="text"
                        name="company_uen"
                        placeholder="Company registration number"
                        value={formik.values.company_uen}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        className={classes.input}
                        helperText={formik.touched.company_uen && formik.errors.company_uen}
                        error={Boolean(formik.touched.company_uen && formik.errors.company_uen)}
                      />
                    </Grid>
                  </>
                )}
                <Grid item xs={12} md={6}>
                  <CustomTextField
                    type="Email"
                    name="email"
                    placeholder="Email*"
                    value={formik.values.email}
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    helpertextposabsl="true"
                    helperText={formik.touched.email && formik.errors.email}
                    error={Boolean(formik.touched.email && formik.errors.email)}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <CustomTextField
                    type="text"
                    name="linkedin"
                    placeholder="LinkedIn"
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    value={formik.values.linkedin}
                    helpertextposabsl="true"
                    helperText={formik.touched.linkedin && formik.errors.linkedin}
                    error={Boolean(formik.touched.linkedin && formik.errors.linkedin)}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <CustomTextField
                    type="password"
                    name="password"
                    placeholder="Password *"
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    value={formik.values.password}
                    helpertextposabsl="true"
                    helperText={formik.touched.password && formik.errors.password}
                    error={Boolean(formik.touched.password && formik.errors.password)}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <CustomTextField
                    type="password"
                    name="c_password"
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    placeholder="Confirm password *"
                    value={formik.values.c_password}
                    helpertextposabsl="true"
                    helperText={formik.touched.c_password && formik.errors.c_password}
                    error={Boolean(formik.touched.c_password && formik.errors.c_password)}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={3} style={{ marginTop: '20px' }}>
                <Grid item xs={12}>
                  <Button
                    size="large"
                    type="submit"
                    color="primary"
                    variant="contained"
                    disabled={!formik.isValid || formik.isSubmitting}
                  >
                    Create account
                  </Button>
                </Grid>
              </Grid>
            </Wrapper>
          </Grid>
        </Grid>
      </Box>
    </form>
  );
};

const GoogleButtonWrapper = styled(Box)({
  '& > div > div > div:first-child': {
    display: process.env.REACT_APP_LOCALHOST === 'true' ? 'block' : 'none !important',
  },
  '& > div > div': {
    display: 'flex',
    justifyContent: 'center',
  },
});

const AutoCompleteWrapper = styled(Box)({
  '& input': {
    borderColor: ({ error }) => error === 'true' && '#f44336',
  },
});
